export default __webpack_public_path__ + "static/media/logo.9db1148e.jpg";